export const actionKey = '@@messages';
